const styles = ({ COLORS }) => ({
  avatar: {
    fontSize: '30px',
    color: '#fff',
    marginRight: '10px',
    display: 'inline-block'
  },
  name: {
    fontSize: '16px',
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  permission: {
    color: '#fff',
    background: '#d6d6d6',
    display: 'inline',
    padding: '5px 10px',
    borderRadius: '4px',
    fontWeight: 'bold'
  },
  pending: {
    background: COLORS.ALERT.WARNING.NORMAL
  },
  approved: {
    background: COLORS.GREEN.NORMAL
  },
  disapproved: {
    background: COLORS.RED.NORMAL
  },
  actions: {
    textAlign: 'right',
    '& > button': {
      marginLeft: '4px'
    }
  }
})

export default styles
